import { render, staticRenderFns } from "./CommonRequestDetail.vue?vue&type=template&id=4cb10282&"
import script from "./CommonRequestDetail.vue?vue&type=script&lang=js&"
export * from "./CommonRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommonRequestDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports